import React from "react";
import { FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";
import "./GalleryLightbox.css";

const isVideoKey = (key) => /\.(mp4|webm|ogg|mov|mkv)$/i.test(key || "");

const getFileName = (key) => {
  if (!key) return "";
  return key.split("/").pop();
};

const GalleryLightbox = ({
  isOpen,
  items = [],
  activeIndex = -1,
  onClose,
  onNext,
  onPrev,
  isLoadingMore = false,
  hasMore = false,
  onTouchStart,
  onTouchEnd
}) => {
  if (!isOpen || activeIndex < 0 || activeIndex >= items.length) {
    return null;
  }

  const currentItem = items[activeIndex];
  const isVideo = isVideoKey(currentItem.key || currentItem.url || "");

  return (
    <div
      className="lightcase-custom-overlay"
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      onClick={(e) => {
        if (e.target.classList.contains("lightcase-custom-overlay") || e.target.classList.contains("lightcase-custom-container")) {
          onClose();
        }
      }}
    >
      {/* Close button */}
      <button className="lightcase-custom-close" onClick={onClose} aria-label="Close Lightbox">
        <FaTimes />
      </button>

      {/* Center media area */}
      <div className="lightcase-custom-container">
        {/* Prev button */}
        <button
          className="lightcase-custom-nav-btn prev"
          onClick={onPrev}
          disabled={activeIndex === 0}
          aria-label="Previous Media"
        >
          <FaChevronLeft />
        </button>

        {/* Media wrapper with changing key to re-trigger zoom animation */}
        <div key={activeIndex} className="lightcase-custom-media-wrapper" onClick={(e) => e.stopPropagation()}>
          {isVideo ? (
            <video
              src={currentItem.url}
              controls
              autoPlay
              playsInline
              crossOrigin="anonymous"
              className="lightcase-custom-video"
            />
          ) : (
            <img
              src={currentItem.url}
              alt={currentItem.key || "Lightbox image"}
              crossOrigin="anonymous"
              className="lightcase-custom-img"
            />
          )}
        </div>

        {/* Next button */}
        <button
          className="lightcase-custom-nav-btn next"
          onClick={onNext}
          disabled={activeIndex === items.length - 1 && !hasMore}
          aria-label="Next Media"
        >
          {isLoadingMore ? (
            <div className="spinner-border spinner-border-sm text-light" role="status" style={{ width: "16px", height: "16px", borderWidth: "2px" }} />
          ) : (
            <FaChevronRight />
          )}
        </button>
      </div>

      {/* Caption information bar */}
      <div className="lightcase-custom-info-bar">
        <span className="lightcase-custom-caption">
          {getFileName(currentItem.key || currentItem.url || "")}
        </span>
        <span className="lightcase-custom-counter">
          {activeIndex + 1} / {items.length}
        </span>
      </div>
    </div>
  );
};

export default GalleryLightbox;
